<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/complaints/register/${inputs.id}`
            : `/complaints/register`
        "
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="reason">Motivo</label>
                <app-input
                  id="inputs_name"
                  type="select"
                  v-model="inputs.reason_id"
                  :list="[
                    { id: '', value: this.$t('select_option') },
                    ...reasonList,
                  ]"
                  :required="true"
                />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("accreditation_area") }}
              </label>
              <app-input
                id="inputs_accreditation_area_id"
                type="select"
                v-model="inputs.accreditation_area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
                v-if="!selectedUrl"
              />

              <app-input
                id="inputs_accreditation_area_id"
                type="select"
                v-model="inputs.accreditation_area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
                v-if="selectedUrl"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("activity") }}
              </label>
              <app-input
                id="inputs_acc_act_id"
                type="select"
                v-model="inputs.acc_act_id"
                :list="accreditationActivityLists"
                :required="true"
                v-if="!selectedUrl"
              />
              <app-input
                id="inputs_acc_act_id"
                type="select"
                v-model="inputs.acc_act_id"
                :list="accreditationActivityLists"
                :required="true"
                v-if="selectedUrl"
              />
            </div>
          </div>

        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { quillEditor },
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {},
      reasonList: [],
      modalId: "modal-add-edit",
      
      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.loaded = true;
    }
    this.dataReason();
  },
  methods: {
    submit() {
        this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = {
        ...response.data,
        accreditation_area_id:
          response.data.accreditation_activity.accreditation_area_id,
      };
      this.onChangeAccreditationArea();
      this.preloader = false;
      this.loaded = true;
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.accreditation_area_id;
        }),
      ];
    },
    dataReason() {
      let reasonListUrl = `complaints/register/reasonComplaintsList/${1}`;
      axiosGet(reasonListUrl).then((response) => {
        this.reasonList = response.data;
      });
    },
  },
};
</script>
<style>
.color-req {
  color: red;
}

.space {
  margin-top: 100px;
}
</style>
